import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import inhouseimage from '../../assets/image/Learning/inhouse.jpg'

export default class inhouse extends Component {
    render() {
        const image=[
            {image:inhouseimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='learning-section'>
                    <Banner bread_crum={['Learning','In-house Workshop']} image={image} title="In-house Workshops" subtitle=""/>
                    <br/><br/>
                    <div className='learning-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Hundreds of organizations have been using our high quality in-class workshops for their training and development needs, with topics ranging from leadership and management, change management, general management, customer services, sales management, marketing management, managing personal effectiveness, human resources, organizational development and many others. Our in-house workshops emphasize on adult learning methodology with practices and roleplays to create a long term impact during implementation process.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
